import { useState, useEffect } from 'react';
import { useKommunaltGalleriService } from '../../../../servicecontexts/KommunaltGalleriServiceContext';

interface ArcGisImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt: string;
}

/**
 * Renders an ArcGIS attachment URL as an authenticated blob URL.
 * Ensures the kommunalt galleri layer is loaded (establishing credentials) before fetching,
 * so the image works on page reload before any other ArcGIS interaction has happened.
 * The blob URL is owned by the service's shared cache, so it is not revoked here.
 */
export function ArcGisImage({ src, alt, ...props }: ArcGisImageProps) {
    const service = useKommunaltGalleriService();
    const [blobUrl, setBlobUrl] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;

        service.fetchAttachmentBlobUrl(src).then(url => {
            if (!cancelled) setBlobUrl(url);
        });

        return () => {
            cancelled = true;
        };
    }, [src]);

    if (!blobUrl) return null;
    return <img src={blobUrl} alt={alt} {...props} />;
}
